export default "__VITE_ASSET__xl1mst9S__"